import { injectFeatureReducer } from '@/platform/state/reducerRegistry'
import { subjectsReducer } from './subjectsSlice'

export function registerSubjectsStore(): void {
  injectFeatureReducer('subjects', subjectsReducer)
}
